/* eslint-disable max-len */
import React, { useEffect } from 'react';
import ReactPaginate from 'react-paginate';

const Pagination = ({ 
    totalPageNumber, selectedPageNumber, handleOnClickPageNumber, TotalCount, selection,emailList, smsList, customers, merchants }) => {
    return (
        <div className={`flex items-center ${selection ? 'justify-between' : 'justify-end'} pb-[25px] pr-10 pl-10 mt-[20px]`}
            data-testid="paginator">
            {(selection) && <div>
                {`${(customers || merchants) === ('select_all' || 'select_all_page') ? (TotalCount === undefined ? '0' : TotalCount) : ((smsList?.length || emailList?.length) === undefined ? '0' : smsList?.length || emailList?.length)} of ${TotalCount} selected`}
            </div>}
            <ReactPaginate
                previousLabel={
                    <a href="#"
                        data-testid="paginator-previous"
                        className={`mr-4 rounded-lg w-[36px] h-[36px] flex justify-center  
                        cursor-default prev 
                         bg-transperant`}>
                        <img loading="lazy" decoding="async" src='/assets/images/Left.svg' alt="icon"
                            className={`w-[14px] ${selectedPageNumber == 1 ? 'cursor-default' : 'cursor-pointer'}`} />
                    </a>
                }
                nextLabel={
                    <a href="#"
                        data-testid="paginator-next"
                        className={` rounded-lg w-[36px] h-[36px] flex justify-center ml-4 next 
                        ${selectedPageNumber == totalPageNumber ? 'cursor-default' : 'cursor-pointer'} bg-transperant`}>
                        <img
                            loading="lazy"
                            decoding="async" src="/assets/images/Right.svg" alt="icon"
                            className={`w-[14px] 
                            ${selectedPageNumber == totalPageNumber ? 'cursor-default' : 'cursor-pointer'}`} />
                    </a>
                }
                breakLabel="..."
                pageCount={totalPageNumber}
                marginPagesDisplayed={2}
                pageRangeDisplayed={3}
                forcePage={selectedPageNumber - 1}
                onPageChange={handleOnClickPageNumber}
                containerClassName="flex justify-center items-center"
                pageClassName="text-xs font-regular text-[#555259] px-2  w-5 h-5 inline-flex
                justify-center items-center ml-2.5 hover:border hover:border-[#106EB4]"
                activeClassName='border border-[#FBEBF4] bg-[#FBEBF4] text-[#9E2064]'
            />
        </div>
    );
};

export default Pagination;
